import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-right: 50px;
  color: var(--global-blue-gray);
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: baseline;
`;

const Time = styled.div`
  margin-left: var(--global-spacing-m);
`;

const Bar = styled.div`
  margin-top: 12px;
  height: 20px;
  width: 105px;
  border-radius: 15px;
  background: linear-gradient(90deg, #e2e558 0%, #13c50e 110.16%);
  @media screen and (max-width: 415px) {
    width: 52px;
    height: 10px;
  }
`;

const BigBar = styled(Bar)`
  width: 320px;
  background: linear-gradient(90deg, #e5ac58 0%, #df6674 100%);
  @media screen and (max-width: 415px) {
    width: 160px;
  }
`;

const Expl = styled.div`
  margin-bottom: 1em;
`;

const Line = styled.hr`
  border: 1px solid var(--global-blue-gray);
`;

const Footer = styled(Expl)`
  font-size: var(--global-font-size-xs);
`;

export const SpeedChart: React.FC = () => {
  return (
    <Container>
      <FlexDiv>
        <Bar />
        <Time>21s</Time>
      </FlexDiv>
      <Expl>
        <em>Semgrep CI </em> (merge request diff scan)
      </Expl>
      <FlexDiv>
        <BigBar />
        <Time>1m04s</Time>
      </FlexDiv>
      <Expl>
        <em>Semgrep CI </em> (full branch scan)
      </Expl>
      <Line />
      <Footer>
        Tests ran 245 rules of the p/security-audit ruleset on 86,000 lines of
        Python and 18,000 lines of JavaScript, on a 2019 MacBook Pro.
      </Footer>
    </Container>
  );
};
